import billInfoComponent from './info/bill-info.component';
import billInfoEditComponent from './edit/bill-info-edit.component';
import billInfoAddComponent from './add/bill-info-add.component';

export default angular
  .module('fizyweb.paycell.billInfo', [])
  .component('fizyPaycellBillInfo', billInfoComponent)
  .component('fizyPaycellBillInfoAdd', billInfoAddComponent)
  .component('fizyPaycellBillInfoEdit', billInfoEditComponent).name;



// WEBPACK FOOTER //
// src/app/buy/bill-info/bill-info-root.module.ts